import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  Typography,
} from "@mui/material";
import Header from "../../components/Header";
import { Cancel, FileDownload } from "@mui/icons-material";
import ConcreteReportView from "./ConcreteReportView";
import { useRef, useState } from "react";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import FieldDensityReportView from "./FieldDensityReportView";
import InterlockReportView from "./InterlockReportView";
const ReportDialog = ({
  isNonMobile,
  colors,
  handleCloseReportPreview,
  open,
  data,
  letterHead,
}) => {
  const printRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [reportNo, setReportNo] = useState("");

  const handleDownloadPdf = async (requestData) => {
    setLoading(true);
    const element = printRef.current;
    if (!element) {
      return;
    }
    const reportNumber =
      requestData.labRequest.year +
      "/" +
      String(requestData.labRequest.id).padStart(4, "0");
    const canvas = await html2canvas(element, {
      scale: 2,
    });
    const data = canvas.toDataURL("image/png");

    const pdf = new jsPDF({
      orientation: "portrait",
      unit: "px",
      format: "a4",
    });
    console.log("@@@@@", data);
    const imgProperties = pdf.getImageProperties(data);
    const pdfWidth = pdf.internal.pageSize.getWidth();

    const pdfHeight = (imgProperties.height * pdfWidth) / imgProperties.width;

    pdf.addImage(data, "PNG", 0, 0, pdfWidth, pdfHeight);
    pdf.save(`JOB_${reportNumber}.pdf`);
    setLoading(false);
  };

  return (
    <div>
      <Dialog
        open={open}
        maxWidth="lg"
        onClose={handleCloseReportPreview}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            {/* <Typography variant="h3" color="success">
              Job Number :{" "}
              {data.labRequest?.year +
                "/" +
                String(data?.labRequest.id).padStart(4, "0")}
            </Typography> */}
          </Box>
        </DialogTitle>
        <Divider />
        <DialogContent>
          <div ref={printRef}>
            {data.reportType === "CONC" ? (
              <ConcreteReportView
                colors={colors}
                data={data}
                isNonMobile={isNonMobile}
                letterHead={letterHead}
              />
            ) : data.reportType === "COM" ? (
              <FieldDensityReportView
                colors={colors}
                data={data}
                isNonMobile={isNonMobile}
                letterHead={letterHead}
              />
            ) : data.reportType === "BLOCK" ? (
              <InterlockReportView
                colors={colors}
                data={data}
                isNonMobile={isNonMobile}
                letterHead={letterHead}
              />
            ) : (
              ""
            )}
          </div>
        </DialogContent>
        <Divider />
        <DialogActions sx={{ paddingRight: "25px" }}>
          <Button
            variant="contained"
            color="secondary"
            autoFocus
            loading={loading}
            startIcon={<FileDownload />}
            onClick={() => handleDownloadPdf(data)}
            size="medium"
          >
            DOWNLOAD PDF
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default ReportDialog;
